import { type RouteRecordRaw } from 'vue-router';
import { Layout } from '@/core/layout/layout';

export default {
    path: '/general-flow-funnel/:id',
    name: 'general-flow-funnel',
    component: () => import('@/components/Funnel/GeneralFlowFunnel/views/GeneralFlowFunnel.vue'),
    meta: {
        private: true,
        layout: Layout.HeaderOnly,
    },
    children: [
        {
            path: 'job',
            name: 'general-flow-job',
            component: () => import('@/components/Funnel/GeneralFlowFunnel/components/Job.vue'),
        },
        {
            path: 'payment',
            name: 'general-flow-payment',
            component: () => import('@/components/Funnel/GeneralFlowFunnel/components/Payment.vue'),
        },
        {
            path: ':(.*)',
            redirect: { name: 'general-flow-funnel' },
        },
    ],
} as RouteRecordRaw;
